module.exports = __webpack_public_path__ + "assets/check_circle-6caa00.svg";